const es = {
  language: { label: 'Idioma' },
  nav: {
    gift: 'Regalo · 90 días gratis',
    pricing: 'Planes y precios',
    features: 'Funciones',
    ecosystem: 'Ecosistema familiar',
    clubs: 'Clubes',
    academy: 'Academia',
    lab: 'ROMIND LAB',
    safety: 'Seguridad',
    research: 'Investigación',
    insights: 'Artículos',
    about: 'Nosotros',
    parentSafety: 'Seguridad para familias',
    joinTesting: 'Unirse a las pruebas',
    contact: 'Contacto',
    toggleMenu: 'Abrir menú',
  },
  download: {
    nav: 'Descargar app',
    cta: 'Descargar en Google Play',
    available: 'Ya disponible',
    headline: '¡ROMIND KIDS ya está en Google Play!',
    description: 'Amistad, creatividad y aprendizaje en un entorno para niños de 9 a 14 años que prioriza la seguridad. Descarga la app para Android.',
    scan: 'Escanea el código QR para abrir ROMIND KIDS en Google Play.',
    qrAlt: 'Código QR para descargar ROMIND KIDS en Google Play',
  },
  footer: {
    tagline: 'Un universo creativo más seguro para niños de 9 a 14 años y la base de ROMIND Family Circle.',
    platform: 'Plataforma',
    legal: 'Legal',
    home: 'Inicio',
    features: 'Funciones de ROMIND KIDS',
    ecosystem: 'Ecosistema familiar',
    clubs: 'Clubes y desafíos',
    academy: 'ROMIND Academy',
    lab: 'ROMIND LAB',
    ventureStudio: 'Venture Studio',
    safety: 'Seguridad',
    safetyResearch: 'Investigación de seguridad',
    parentSafety: 'Seguridad para familias',
    insights: 'Artículos',
    joinTesting: 'Unirse a las pruebas',
    about: 'Nosotros',
    contact: 'Contacto',
    privacy: 'Política de privacidad',
    terms: 'Términos del servicio',
    copyright: 'Contenido de usuario y derechos de autor',
    community: 'Normas de la comunidad',
    childSafetyModeration: 'Seguridad infantil y moderación',
    reportHandling: 'Gestión de reportes',
    dataRetention: 'Conservación y eliminación de datos',
    deleteAccount: 'Eliminar cuenta',
    childSafetyOverview: 'Resumen de seguridad infantil',
    childSafetyResearch: 'Investigación sobre seguridad infantil',
    rights: '© 2025–2026 ROMIND KIDS — proyecto gestionado por su fundador. Todos los derechos reservados.',
    safetyPrinciples: 'Diseñado conforme a principios de seguridad infantil',
  },
  legal: {
    eyebrow: 'Legal',
    back: 'Volver a ROMIND KIDS',
    lastUpdated: 'Última actualización: {date}',
    operatorInfo: 'Información del operador:',
    otherDocs: 'Otros documentos legales y de seguridad',
  },
};

export default es;